export default {
  helpful: {
    en: 'Helpful?',
  },
}
